import { Truck } from 'lucide-react';
import { useDeliverySettings } from '@/hooks/useDeliverySettings';

export function PromoBanner() {
  const { data: settings, isLoading } = useDeliverySettings();

  if (isLoading) return null;
  if (!settings?.freeDeliveryEnabled) return null;

  const thresholdNIS = settings.freeDeliveryThreshold / 100;
  const displayText = (settings.promoBannerText || 'משלוח חינם בהזמנה מעל ₪{threshold}!')
    .replace('{threshold}', String(thresholdNIS));

  return (
    <div className="bg-primary text-primary-foreground py-2.5 text-center text-sm font-medium">
      <div className="container mx-auto px-4 flex items-center justify-center gap-2">
        <Truck className="h-4 w-4" />
        <span>{displayText}</span>
      </div>
    </div>
  );
}
